import React, { forwardRef, useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import { editorS3FileManagerServices } from "../../../APIServices/Editor/editorS3FileManagerServices";
import { useParams } from "react-router";

const GenerateZipFile = forwardRef(({ Show, Hide, Title, sourceKey, setFileFolderUpdater }, ref) => {
  const [buttonLoader, setButtonLoader] = useState(false);
  const [name, setName] = useState("");
  const { studyId } = useParams()

  const createS3ZipController = async () => {
    setButtonLoader(true)
    let userData = { studyId };
    userData.paths = sourceKey
    userData.zipName = name
    let data = await editorS3FileManagerServices.createS3ZipController(
      userData
    );
    setButtonLoader(false)
    if (data?.statusCode === 200) {
      setFileFolderUpdater(Math.floor(1000000000 + Math.random() * 9000000000));
      setName("")
      Hide()
    }
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <div ref={ref} className="d-flex flex-column h-100">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>{Title}</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Form.Group className="mb-1">
              <Form.Label className="mb-1 fw-bold">
                Zip Name{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                type="text"
                rows={3}
                onChange={(e) => setName(e.target.value)}
                value={name}
                className="fontSize12"
                placeholder="Enter Zip Name"
              />
            </Form.Group>
          </Offcanvas.Body>
          <div className="text-end p-2 border-top">
            <button
              onClick={createS3ZipController}
              disabled={buttonLoader || !name}
              title={Title}
              className="updateProfile"
            >
              {buttonLoader ? (
                <div className="hstack gap-2">
                  <Spinner size="sm" /> Compressing...
                </div>
              ) : (
                "Compress Now"
              )}
            </button>
          </div>
        </div>
      </Offcanvas>
    </>
  );
});

export default GenerateZipFile;
